import React, { useState } from 'react';
import { View, Text } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';

const AssetsByLocationReport = ({ data }) => {
  const [locationId, setLocationId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'assets-by-location-report',
      params: { 'location-id': locationId },
    });
  };

  const locations = data?.locations.map(location => ({
    id: location.id,
    name: `${location.city}, ${location.state} - ${location.street}`,
  }));

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Assets By Location Report</Text>
      <Text style={styles.label}>Location:</Text>
      <select
        style={styles.select}
        onChange={(e) => setLocationId(e.target.value)}
      >
        <option key="location-nil" value="">Select Location</option>
        <option key="location-unassigned" value="unassigned">Unassigned</option>
        {locations?.map(location => (
          <option key={location.id} value={location.id}>{location.name}</option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default AssetsByLocationReport;
